import React from "react"
import '../Styles/footer.css'

function Footer() {
  
   // for dynamic year
  const currentDate=new Date();
  const year= currentDate.getFullYear();
        
                 
    return (
        <>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <div className="footer">
        <p>Copyright © {year} Created by Shailesh Joshi</p>
      </div>
      </>
    )
  }
  export default Footer
  


